import { render, staticRenderFns } from "./LocationApiManagement.template.vue?vue&type=template&id=0b352778&scoped=true&"
var script = {}
import style0 from "./LocationApiManagement.template.vue?vue&type=style&index=0&id=0b352778&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b352778",
  null
  
)

export default component.exports